module.exports = __webpack_public_path__ + "img/titulo_sistema.8cb8861b.png";